import { useCallback } from "react";

import { useLibrary } from "../../../providers";
import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";

import { API } from "./api";

import type { IncomeReportingFormValues } from "./types";

export const useCreateIncomeSource = () => {
  const l10n = useLibrary("translations");
  const { send, loading } = useRequestWithFeedback<API.IncomeSource>();

  const createIncomeSource = useCallback(
    (
      formData: IncomeReportingFormValues,
      overrideRunProps?: OverrideRunProps<API.IncomeSource>,
    ) => {
      send({
        action: API.createIncomeSource(formData),
        messaging: {
          toast: {
            success: l10n.getString(
              "income-reporting-create-success",
              null,
              "Income added.",
            ),
            error: l10n.getString(
              "income-reporting-create-error",
              null,
              "Unable to add your income. Please try again later.",
            ),
          },
        },
        ...overrideRunProps,
      });
    },
    [l10n, send],
  );

  return { createIncomeSource, loading };
};

export const useEditIncomeSource = () => {
  const l10n = useLibrary("translations");
  const { send, loading } = useRequestWithFeedback<API.IncomeSource>();

  const editIncomeSource = useCallback(
    (
      formData: IncomeReportingFormValues,
      uuid: string,
      overrideRunProps?: OverrideRunProps<API.IncomeSource>,
    ) => {
      send({
        action: API.editIncomeSource(formData, uuid),
        messaging: {
          toast: {
            success: l10n.getString(
              "income-reporting-edit-success",
              null,
              "Income updated.",
            ),
            error: l10n.getString(
              "income-reporting-edit-error",
              null,
              "Unable to update your income. Please try again later.",
            ),
          },
        },
        ...overrideRunProps,
      });
    },
    [l10n, send],
  );

  return { editIncomeSource, loading };
};
